import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'

@Module({
  namespaced: true
})
export default class AutomotiveStore extends VuexModule {
  brandsLoaded = false
  brands: KwixeoSales.CarBrands = []

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['Brands']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  // Sort a list alphabetically
  @Mutation
  orderList (param: { list: KwixeoInterface.GenericObject[]; key: string }): void {
    const key = param.key
    param.list.sort((a, b) => {
      const aKey = a[key].toLowerCase()
      const bKey = b[key].toLowerCase()
      if (aKey < bKey) return -1
      else if (aKey > bKey) return 1
      else return 0
    })
  }

  @Mutation
  setBrandsLoaded (state = true): void {
    this.brandsLoaded = state
  }

  @Mutation
  setBrands (brands: KwixeoSales.CarBrands): void {
    this.brands = brands
  }

  @Mutation
  updateBrand (brand: KwixeoSales.CarBrand): void {
    if (!this.brandsLoaded) {
      return
    }
    const index = this.brands.findIndex(type => type.id === brand.id)
    if (index >= 0) {
      Vue.set(this.brands, index, brand)
    } else {
      this.brands.push(brand)
    }
  }

  @Mutation
  removeBrand (brand: KwixeoSales.CarBrand): void {
    if (!this.brandsLoaded) {
      return
    }
    const index = this.brands.findIndex(type => type.id === brand.id)
    if (index >= 0) {
      Vue.delete(this.brands, index)
    }
  }

  @Action
  async loadBrands (force = false): Promise<void> {
    if (!this.brandsLoaded || force) {
      const response = await Vue.prototype.$kwSales.axios.get('/automotive/brand?per_page=500&sort=name&include=models')
      await this.context.commit('setBrands', response.data.data)
      this.context.commit('setBrandsLoaded')
    }
  }

  @Action
  async loadBrand (id: number): Promise<void> {
    if (this.brandsLoaded) {
      const response = await Vue.prototype.$kwSales.axios.get('/automotive/brand/' + id + '?include=models')
      await this.context.commit('updateBrand', response.data)
    }
  }

  @Action
  setBrand (brand: KwixeoSales.CarBrand): void {
    this.context.commit('updateBrand', brand)
    if (this.brandsLoaded) {
      this.context.commit('orderList', { list: this.brands, key: 'name' })
    }
  }

  @Action
  deleteBrand (brand: KwixeoSales.CarBrand): void {
    this.context.commit('removeBrand', brand)
  }

  get models (): KwixeoSales.CarBrandModelFilter[] {
    const models: KwixeoSales.CarBrandModelFilter[] = []
    this.brands.forEach(brand => {
      if (brand.models && brand.models.length > 0) {
        models.push({
          id: 'brand' + brand.id,
          name: brand.name,
          disabled: true
        })
        models.push(...brand.models)
      }
    })
    return models
  }
}
